




















import { Component, Prop, Vue } from 'vue-property-decorator'
import TitleEditor, { EditorTracker } from '@/components/TitleEditor.vue'
import { Card } from '@alpha/ink'
import store from '@/store'
import A from '@/utilities/alpha'
import * as graph from '@shared/types/graphql'
import { TrackKeys } from '@/utilities/v-track-directive'

@Component({
  components: {
    TitleEditor,
    Card
  }
})
export default class VariantTitleEditor extends Vue {
  @Prop({ required: true }) option!: graph.QuestionOption

  saving: boolean = false
  currentValue:string = this.currentTitle
  track: EditorTracker = {
    input: TrackKeys.questionTitleInput,
    save: TrackKeys.questionTitleSave,
    cancel: TrackKeys.questionTitleCancel,
    revert: TrackKeys.questionConfigRevert
  }

  get config () {
    const optionConfig = store.getters.surveyConfiguration.optionConfigById(this.option.id)
    return {
      value: optionConfig?.title || ''
    }
  }

  // Option Title Config Specific Methods
  updateOptionConfigTitleValue (value: string) {
    this.currentValue = value
  }

  cancelOptionConfigTitle () {
    this.currentValue = this.currentTitle
    this.setTitleEditMode(false)
  }

  async revertOptionConfigTitle () {
    if (this.currentValue !== this.option.label) {
      this.currentValue = this.option.label || ''
    } else if (this.config?.value && this.config.value !== this.currentValue) {
      this.currentValue = this.config.value
    }
  }

  async saveOptionConfigTitle () {
    this.saving = true
    try {
      if (this.option.label === this.currentValue) {
        await store.dispatch.surveyConfiguration.deleteOptionText(this.option.id)
      } else {
        const title = A.stripHTML(this.currentValue)
        await store.dispatch.surveyConfiguration.updateOptionConfig({ questionOptionId: this.option.id, title })
        this.currentValue = this.currentTitle
      }
    } catch (error) {
      console.error(error)
    } finally {
      this.saving = false
      this.setTitleEditMode(false)
    }
  }

  get currentTitle () {
    return this.config.value || this.option.label || ''
  }

  setTitleEditMode (mode: boolean) {
    this.$emit('setTitleEditMode', mode)
  }
}
